/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/new/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var getAbsoluteUrl = (function() {
	    var a;
	
	    return function(url) {
	        if(!a) a = document.createElement('a');
	        a.href = url;
	
	        return a.href;
	    };
	})();
	var res = $.extend({}, response);
	var Modal = __webpack_require__(1);
	var timer = __webpack_require__(2);
	// var panguLogin = require('pangu-login');
	
	// 分享
	(function () {
	    var obj = {
	        title: "新服专享活动-《天谕》官方网站",
	        desc: "#天谕新服预约福利开启#仅需3步完成角色预约，享六大任性特权，免排队特权、外星人笔记本、永久专属挂饰等奖励。还有签到抽iPhone6s，首冲返现，至尊归来礼等你来领",
	        pic: getAbsoluteUrl(__webpack_require__(3)),
	        url: window.location.href
	    };
	
	    var weiboobj = {
	        title: obj.title,
	        desc: encodeURIComponent(obj.desc),
	        pic: encodeURIComponent(obj.pic),
	        url: encodeURIComponent(obj.url)
	    };
	
	
	    $('.share-btn').click(function (event) {
	        var id = $(this).data("id");
	        switch (id) {
	            case "yx":
	                snsShare.init(obj);
	                snsShare.toYixin();
	                break;
	            case "xl":
	                snsShare.init(weiboobj);
	                snsShare.toSinaWeibo();
	                break;
	            case "wx":
	                snsShare.init(obj);
	                var url="http://res.nie.netease.com/comm/js/nie/util/share/api/index.html?url="+window.location.href;
	                window.open(url,'','width='+640+',height='+480);
	                break;
	        }
	    });
	
	    $(".f-share-icon").hover(
	        function(){
	            $(".f-share-icon").addClass("active");
	        },
	        function(){
	            $(".f-share-icon").removeClass("active");
	        }
	    );
	})();
	
	// 快速注册
	(function () {
	    function reg_success_callback(e) {
	        $("<a>").attr({
	            href: "javascript:location.reload()"
	        }).addClass("register__btn")
	          .css({ marginBottom: 10 })
	          .html("返回 &gt;&gt;").appendTo(e);
	    }
	
	    nie.define('common', function () {
	        var fur2 = nie.require("nie.util.fur3");
	
	        new fur2({
	            holder: '#fab-reg',                     
	            product: 'tianyu_web',  
	            host: location.hostname,
	            promark: "UjDQJOg",
	            pop: false,
	            cb: function(){
	                reg_success_callback("#fab-reg"); 
	            }
	        });
	
	        $('.fur-username .fur-placeholder span').text('请输入您的网易通行证');
	        $('.fur-password .fur-placeholder span').text('请输入您的密码');
	        $('.fur-btn-submit span').text('完成快速注册');
	    });
	})();
	
	// 如何获取
	(function () {
	    var subscribeModal = new Modal('.js-subscribe-modal');
	    var $tips = $('.js-tip');
	    var $subscribeBodys = $('.js-subscribe-body');
	
	    $tips.click(function () {
	        var name = $(this).data('target');
	
	        $subscribeBodys.hide().filter('[data-name=' + name + ']').show();
	        subscribeModal.open();
	    });
	})();
	
	// 初始化倒计时
	(function () {
	    if (res.startTime <= timer.now()) {
	        var $timer1Numbers = $('.js-timer1 .js-number');
	        var $timer2Numbers = $('.js-timer2 .js-number');
	
	        timer.init(
	            res.endTime, // 时间
	            function render (t) {
	                var str = '' + t.d + t.h + t.m;
	                $timer1Numbers.each(function (i) {
	                    $timer1Numbers.eq(i).text(str[i]);
	                });
	            },
	            function end () {
	                $('.js-timer1').html('');
	            }
	        );
	
	        timer.init(
	            res.endTime, // 时间
	            function render (t) {
	                var str = '' + t.d + t.h + t.m;
	                $timer2Numbers.each(function (i) {
	                    $timer2Numbers.eq(i).text(str[i]);
	                });
	            },
	            function end () {
	                $('.js-timer2').html('');
	            }
	        );
	    } else {
	        $('.js-timer1, .js-timer2').hide();
	    }
	})();
	
	var onNavChanges = [];
	
	// 导航
	(function () {
	    var $nav = $('.js-nav');
	    var $navItems = $nav.find('a');
	    var navTop = $nav.offset().top;
	    var $panels = $('.panel[data-name]');
	    var minWidth = 1236;
	    var navStatus = 'normal';
	
	    $navItems.add($('.js-top-nav a')).click(function (e) {
	        if ($(this).hasClass('disabled')) {
	            e.preventDefault();
	        }
	
	        if (location.hash === $(this).attr('href')) {
	            hashChangeHandler();
	        }
	    });
	
	    $(window).on('scroll', positionNav);
	    $(window).on('resize', positionNav);
	
	    // 当IE8设置IE7兼容模式时，window中有onhashchange属性，但并不支持
	    // 所以这里需要同时判断文档模式是否大于7
	    var docMode = document.documentMode;
	
	    if('onhashchange' in window && ( docMode === undefined || docMode > 7 )){
	        $(window).on('hashchange', hashChangeHandler);
	    }else{
	        var oldHash = location.hash;
	
	        setInterval(function(){
	            var newHash = location.hash;
	
	            if(newHash != oldHash){
	                hashChangeHandler();
	                oldHash = newHash;
	            }
	        }, 100);
	    }
	
	    hashChangeHandler();
	
	    function hashChangeHandler () {
	        if (!location.hash || location.hash === '#') {
	            return;
	        }
	
	        if ($(window).scrollTop() !== navTop) {
	            $('html, body').animate({ scrollTop: navTop });
	        }
	        var name = location.hash;
	
	        if ($navItems.filter('[href=' + name + ']').hasClass('disabled')) { return; }
	
	        $navItems.removeClass('active').filter('[href=' + name + ']').addClass('active');
	        $panels.removeClass('active').filter('[data-name=' + name.replace('#', '') + ']').addClass('active');
	
	        $.each(onNavChanges, function (i, item) {
	            if (item.name === name) {
	                item.callback();
	            }
	        });
	    }
	
	    // 设置导航的位置
	    function positionNav () {
	        var scrollTop = $(window).scrollTop();
	        var width = $(window).width();
	
	        if (scrollTop >= navTop) {
	            $nav.addClass('fixed');
	
	            if (width < minWidth) {
	                $nav[0].style.marginLeft = 0;
	                $nav[0].style.left = -$(window).scrollLeft() + 'px';
	            } else {
	                $nav[0].style.marginLeft = '';
	                $nav[0].style.left = '';
	            }
	        } else {
	            $nav.removeClass('fixed');
	            $nav[0].style.marginLeft = '';
	            $nav[0].style.left = '';
	        }
	    }
	})();
	
	// 登录
	var loginModal = new Modal('.js-login-modal');
	var panguLogin = pangu.login.Login;
	var login = new panguLogin({
	    newCDN:1, // 代表使用的CDN是连通性更好的SNI域名
	    version:3, // 代表版本3,
	    product : 'd21', //【必须】使用的产品ID，如urs
	    promark : 'dNvgFOK', //【必须】【申请】申请的组件ID，被分派ID
	    host : 'hd.tianyu.163.com',
	    productKey: '1bc7680eee080ce2026757eca30d0e53',
	    el: document.getElementById('login'),
	    boxWidth: 320
	}, {
	    newCDN:1, // 代表使用的CDN是连通性更好的SNI域名
	    version:3, // 代表版本3,
	    product : 'd21', //【必须】使用的产品ID，如urs
	    promark : 'dNvgFOK', //【必须】【申请】申请的组件ID，被分派ID
	    host : 'hd.tianyu.163.com',
	    productKey: '1bc7680eee080ce2026757eca30d0e53',
	    logincb: function () {
	        location.reload();
	    },
	    regcb: function () {
	        location.reload();
	    }
	});
	
	$('.js-login').click(function () {
	    loginModal.open();
	    login.urs.prepareIframe();
	});
	$('.js-logout').attr('href', 'http://reg.163.com/Logout.jsp?username=' + encodeURIComponent(res.urs) + '&url=' + encodeURIComponent(location.href))
	    .on('click', function (e) {
	        e.stopPropagation();
	    });
	
	(function () {
	    // 签到
	    // 渲染签到表格
	    function renderTable () {
	        var oneDay = 1000 * 3600 * 24;
	        var start = new Date(res.startTime);
	        var end = new Date(res.signEndTime);
	        var now = new Date(res.now);
	        var html = '';
	
	        var nowTime = timer.startOfDay(now);
	
	        // 计算开始的天
	        var renderStart = res.startTime - (14 - Math.ceil((res.signEndTime - res.startTime) / oneDay)) * oneDay / 2;
	
	        for (var i = 0, temp, className; i < 14; i++) {
	            temp = timer.startOfDay(new Date(renderStart + oneDay * i));
	
	            if (res.qianDaoInfo.indexOf(temp) > -1) {
	                className = ' active';
	            } else if (temp < timer.startOfDay(res.startTime) ||
	                temp > timer.startOfDay(res.signEndTime)) {
	                className = ' disabled';
	            } else {
	                className = '';
	            }
	            
	            html += '<div class="signin__day' + className + '" data-time="' + temp + '"><span></span>' + new Date(temp).getDate() + '</div>';
	        }
	
	        $('.js-signin-list').html(html);
	    }
	
	    function renderBtn () {
	        var now = timer.now();
	        var $btns = $('.js-signin-group a');
	        var nowStart = timer.startOfDay(now);
	
	        $btns.hide();
	
	        if (res.qianDaoInfo.indexOf(nowStart) > -1) {
	            $btns.filter('.js-signined').css({ display: 'block' });
	        } else if (now < res.startTime) {
	            $btns.filter('.js-signin-unstart').css({ display: 'block' });
	        } else if (now > res.signEndTime) {
	            $btns.filter('.js-signin-ended').css({ display: 'block' });
	        } else {
	            $btns.filter('.js-signin').css({ display: 'block' });
	        }
	    }
	
	    renderTable();
	    renderBtn();
	
	    var signining = false;
	
	    $('.js-signin').click(function () {
	        if (!res.logined) {
	            loginModal.open();
	            login.urs.prepareIframe();
	            return;
	        }
	
	        if (signining) { return; }
	        signining = true;
	
	        $.ajax({
	            url: '/qiandao/signIn',
	            dataType: 'json'
	        })
	        .done(function (r) {
	            if (r.retObj === 0) {
	                res.qianDaoInfo += ',' + timer.startOfDay(timer.now());
	                renderBtn();
	                renderTable();
	                $('.js-signin-count').text(+$('.js-signin-count').text() + 1);
	            } else {
	                error();
	            }
	        })
	        .fail(error)
	        .always(function () {
	            signining = false;
	        })
	    });
	
	    function error () {
	        alert('签到失败，请重试');
	    }
	})();
	
	// 查看特权状态
	(function () {
	    var $label = $('.js-state-label');
	    var $input = $('.js-state-input');
	
	    $input.focus(function () {
	        $label.hide();
	    });
	
	    $input.blur(function () {
	        if (!$input.val()) {
	            $label.show();
	        }
	    });
	
	    $('.js-state-submit').click(function () {
	        $('.js-state-form').submit();
	    });
	
	    var stateModal = new Modal('.js-state-modal');
	    var stateAlert = function (msg) {
	        $('.js-state-modal-body').html(msg);
	        stateModal.open();
	    };
	
	    $('.js-state-form').submit(function (e) {
	        e.preventDefault();
	
	        var urs = $.trim($input.val());
	
	        if(!urs){
	            alert("请输入通行证帐号");
	            return;
	        }
	        $.getJSON("/recruit/getServerId.json?callback=?&urs=" + urs + "&r=" + Math.random(), function (msg) {
	            if(msg.server_id > 0){
	              var obj={
	                serverName:msg.serveName,
	                urs:msg.ursname
	              }
	              var html = ['<p class="p2">恭喜！您的帐号 <span>' + obj.urs + '</span></p>',
	                '<p class="p1">已成功激活<span class="serverName">【' + obj.serverName + '】</span>服务器免排队特权！</p>'].join("");
	
	              stateAlert(html);
	            }else{
	              stateAlert('<p>您尚未获得免排队资格！</p>');
	            }
	        })
	    });
	
	    // 初始化服务器预约情况
	    $.getJSON("/reserve/status?callback=?&r="+Math.random(), function (msg) {
	        if(msg.errorCode != 0){
	            alert(msg.message);
	            return;
	        }
	
	        var html="";
	
	        //msg.data = {"锦绣河山":"即将开启","忆江南":"即将开启","白云山":"即将开启"};
	        $.each(msg.data, function(key, server){
	            var state = "";
	
	            if(server=="预约开启"){
	                state = "开启";
	            }else if(server=="火爆预约"){
	                state = "火爆";
	            }else if(server=="预约已满"){
	                state="已满";
	            }else if(server=="即将开启"){
	                state="14:00预约开启";
	            }
	
	            html += ['<div class="server__item">',
	                        '<h4>'+ key +'</h4>',
	                        '<p>' + state + '</p>',
	                    '</div>'].join("");
	        });
	
	        $(".js-server-list").html(html);
	    });
	})();
	
	// 开服7天礼
	(function () {
	    var $sevenTabs = $('.js-seven-tab a');
	    var $sevenTabcontents = $('.js-seven-tabcontent div');
	
	    $sevenTabs.on('click', function () {
	        var index = $sevenTabs.index($(this));
	
	        $sevenTabs.removeClass('active').eq(index).addClass('active');
	        $sevenTabcontents.removeClass('active').eq(index).addClass('active');
	    });
	})();
	
	// 抽奖效果
	(function () {
	    var drawing = false;
	    var lotteryModal = new Modal('.js-lottery-modal');
	    var alert = function (name) {
	        var $body = $('.js-lottery-modal-body').hide().filter('[data-type=' + name +']').show();
	
	        lotteryModal.open();
	
	        return $body;
	    };
	    var $drawHighlight = $('.js-lottery-highlight');
	    var Draw = __webpack_require__(4);
	    // 如果新增奖品，需要在以下地方添加对应代码
	    // var awardMap
	    // var draw
	    // function onDrawEnd
	    // function renderTable
	    var awardMap = {
	        1: 'iPhone 6s',
	        2: '游戏键盘',
	        3: '免排队特权',
	        4: '云垂礼盒（精装版）',
	        5: '10元京东优惠券',
	        6: '5元网易点卡',
	        7: '英伟达GTX1080显卡',
	        8: '外星人笔记本',
	        9: '10元网易点卡',
	        10: '小玄鲸',
	        11: '玄极抱枕',
	        12: '50元网易点卡'
	    };
	    var draw = new Draw(
	        [
	            { type: 2, x: 0, y: 0 },
	            { type: 0, x: 1, y: 0 },
	            { type: 9, x: 2, y: 0 },
	            { type: 8, x: 3, y: 0 },
	            { type: 12, x: 3, y: 1 },
	            { type: 10, x: 3, y: 2 },
	            { type: 11, x: 2, y: 2 },
	            { type: 6, x: 1, y: 2 },
	            { type: 4, x: 0, y: 2 },
	            { type: 3, x: 0, y: 1 }
	        ],
	        function onDrawStart () {
	            $drawHighlight.show();
	        },
	        function onDrawProcess (index) {
	            var current = this.list[index];
	
	            $drawHighlight.css({
	                top: 14 + (153 + 6) * current.y,
	                left: 21 + (296 + 6) * current.x
	            });
	        },
	        function onDrawEnd () {
	            if (this.immediateStop) {
	                $drawHighlight.hide();
	            } else {
	                switch (draw.gift.extraId) {
	                    case 0:
	                        alert('xx');
	                        break;
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 7:
	                    case 8:
	                    case 10:
	                        alert('shiwu').find('.js-text').text(draw.gift.description);
	                        break;
	                    case 3:
	                        alert('paidui').find('.js-text').text(draw.gift.description);
	                        break;
	                    case 5:
	                        alert('jd').find('.js-name').text(awardMap[draw.gift.extraId])
	                            .end().find('.js-text').text(draw.gift.description);
	                        break;
	                    case 6:
	                    case 9:
	                        alert('dk').find('.js-name').text(awardMap[draw.gift.extraId])
	                            .end().find('.js-text').each(function (i, el) {
	                            $(el).text(draw.gift.description.split(',')[i]);
	                        });
	                        break;
	                }
	
	                if (draw.gift.extraId !== 0) {
	                    res.lotteryList.push(draw.gift);
	                }
	            }
	        }
	    );
	
	    $('.js-lottery-record').click(function () {
	        if (res.lotteryList.length) {
	            renderTable(alert('jl').find('.js-record'));
	        } else {
	            alert('mjl');
	        }
	    });
	
	    $('.js-lottery').on('click', function () {
	        if (!res.logined) {
	            loginModal.open();
	            login.urs.prepareIframe();
	            return;
	        }
	
	        if (draw.status !== 'stop') { return; }
	
	        if (res.leftCount <= 0) {
	            alert('jh');
	            return;
	        }
	
	        draw.start();
	
	        $.ajax({
	            url: '/new/drawLottery.json',
	            dataType: 'json'
	        })
	        .done(function (r) {
	            if (r.resCode === 0) {
	                res.leftCount--;
	                $('.js-left-count').text(res.leftCount);
	                draw.gift = r.data;
	                draw.setLottery(indexOf(draw.list, r.data.extraId));
	            } else if (r.resCode === 11) {
	                draw.stop();
	                loginModal.open();
	                login.urs.prepareIframe();
	            } else if (r.resCode === 24005) {
	                draw.stop();
	                alert('jh');
	                res.leftCount = 0;
	                $('.js-left-count').text(0);
	            } else {
	                draw.stop();
	                alert('抽奖出错，请重试');
	            }
	        })
	        .fail(function () {
	            draw.stop();
	            alert('抽奖出错，请重试');
	        });
	    });
	
	    function indexOf (list, id) {
	        for (var i = 0; i < list.length; i++) {
	            if (list[i].type === id) {
	                return i;
	            }
	        }
	    }
	
	    function renderTable ($table) {
	        var html = '';
	
	        html += $.map(res.lotteryList, function (lottery) {
	            var name = '';
	            var code = ''
	
	            if (lottery.extraId === 1 ||
	                lottery.extraId === 2 ||
	                lottery.extraId === 4 ||
	                lottery.extraId === 10) {
	                name = lottery.description;
	                code = '实物奖品';
	            } else if (lottery.extraId === 3) {
	                name = lottery.description;
	                code = '游戏特权';
	            } else if (lottery.extraId === 5) {
	                name = awardMap[lottery.extraId];
	                code = '优惠码：' + lottery.description + '，<a class="text--danger" href="http://coupon.jd.com/ilink/ex/change_index.action" target="_blank">兑换地址</a>';
	            } else if (lottery.extraId === 6) {
	                name = awardMap[lottery.extraId];
	                code = '卡号：' + lottery.description.split(',').join('，卡密：');
	            }
	
	            return '<tr>' +
	                '<td>' + name + '</td>' +
	                '<td>' + code + '</td>' +
	            '</tr>'
	        }).join('');
	
	        $table.html(html);
	    }
	
	    getRecord();
	    onNavChanges.push({
	        name: '#shiwu',
	        callback: scrollRecord
	    })
	
	    $('.js-lottery-record-list').hover(
	        function () {
	            $(this).stop();
	        },
	        scrollRecord
	    );
	
	    // 滚动名单
	    function getRecord () {
	        $.ajax({
	            url: '/new/rewardList.json',
	            dataType: 'json'
	        })
	        .done(function (r) {
	            if (r.resCode === 0) {
	                renderRecord(r.data);
	            }
	        });
	    }
	
	    function renderRecord (data) {
	        var $list = $('.js-lottery-record-list');
	        var list = [];
	
	        $.each(data, function (key, users) {
	            $.each(users, function (_, user) {
	                list.push({ id: key, user: user });
	            });
	        });
	
	        if (list.length % 2) {
	            list.length = list.length - 1;
	        }
	
	        // 随机打乱
	        $.each(list, function (i, item) {
	            var index = Math.floor(Math.random() * list.length);
	            list[i] = list[index];
	            list[index] = item;
	        });
	
	        if (list.length >= 10) {
	            list = list.concat(list.slice(0, 8));
	        }
	
	        $list.html(
	            $.map(list, function (item) {
	                return '<li>' + item.user + ' 获得了' + awardMap[item.id] + '</li>'
	            }).join('')
	        );
	
	        scrollRecord();
	    }
	
	    function scrollRecord () {
	        var $list = $('.js-lottery-record-list');
	        var distance = $list.parent().height() - $list.height();
	        var offset = parseInt($list.css('top'));
	
	        if (offset === distance) {
	            $list.css({ top: 0 });
	            offset = 0;
	        }
	
	        if (distance < -30) {
	            $list.stop().animate({ top: distance }, (-distance + offset) * 5000 / 100, 'linear', scrollRecord);
	        }
	    }
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	var html = '<div class="modal">' +
	    '<div class="modal__mask"></div>' +
	    '<div class="modal__body js-body"></div>' +
	'</div>';
	
	function Modal (body) {
	    this.$el = $(html);
	    this.$body = $(body);
	    this.$body.show();
	    this.$el.find('.js-body').append(this.$body);
	    $('.wrap').append(this.$el);
	
	    this.$el.on('click', '.js-close', $.proxy(function () {
	        this.close();
	    }, this));
	}
	
	Modal.prototype = {
	    constructor: Modal,
	    open: function () {
	        this.$el.show();
	        this.$el.find('.js-body').css({
	            top: $(window).scrollTop() + $(window).height() / 2 - this.$body.outerHeight() / 2
	        });
	    },
	    close: function () {
	        this.$el.fadeOut();
	    }
	}
	
	module.exports = Modal;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	// 倒计时
	var systemTime = 0;
	var timers = [];
	var running = false;
	var localStartTime = 0; // 本地初始化的时间，用来记录本地时间间隔，计算出系统时间
	var res = $.extend({}, response);
	
	systemTime = res.now / 1000;
	localStartTime = new Date().getTime();
	
	function start (loop) {
	    running = true;
	    run(loop);
	}
	
	function run (loop) {
	    if (!timers.length) {
	        running = false;
	        return;
	    }
	
	    var localSpan = new Date().getTime() - localStartTime;
	    var lastSystemTime = systemTime + Math.floor(localSpan / 1000);
	
	    for (var i = 0; i < timers.length; i++) {
	        var myTime = timers[i].time / 1000;
	        var overD = Math.floor((myTime - lastSystemTime) / 60 / 60 / 24);
	        var overH = Math.floor((myTime - lastSystemTime) / 60 / 60 - overD * 24);
	        var overM = Math.floor((myTime - lastSystemTime) / 60 - overD * 24 * 60 - overH * 60);
	        var span = {
	            d: overD,
	            h: overH,
	            m: overM
	        };
	
	        for (var k in span) {
	            if (span[k] < 10) {
	                span[k] = '0' + span[k];
	            }
	        }
	
	        timers[i].render && timers[i].render(span);
	
	        if (lastSystemTime >= myTime) {
	            // 如果已经结束，不再进入计时循环
	            timers[i].end && timers[i].end();
	            timers.splice(i, 1);
	            i--;
	        }
	    }
	    loop && setTimeout(run, 1000 * 60);
	}
	
	module.exports = {
	    init: function (time, render, end) {
	        timers.push({
	            render: render,
	            time: time,
	            end: end
	        });
	        if (!running) {
	            start(true);
	        } else {
	            run();
	        }
	    },
	    now: function () {
	        return systemTime * 1000 + (new Date().getTime() - localStartTime);
	    },
	    startOfDay: function (time) {
	        var date = new Date(time);
	
	        date.setHours(0);
	        date.setMinutes(0);
	        date.setSeconds(0);
	        date.setMilliseconds(0);
	
	        return date.getTime();
	    }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d007d4c478543b3cd8e5253131b064a9.jpg";

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	function Draw (gifts, onStart, onStep, onEnd) {
	    this.list = gifts;
	    this.current = null;
	    this.index = 0;
	    this.minInterval = 100;
	    this.maxInterval = 400;
	    this.stepInterval = 50;
	    this.currentInterval = this.maxInterval;
	    this.onStep = onStep;
	    this.onStart = onStart;
	    this.onEnd = onEnd;
	    this.status = 'stop';
	}
	
	Draw.prototype = {
	    constructor: Draw,
	    start: function () {
	        if (this.status !== 'stop') { return; }
	        this.startTime = new Date().getTime();
	
	        this.onStart();
	        this.status = 'start';
	        this.step();
	    },
	    stop: function () {
	        this.immediateStop = true;
	    },
	    setLottery: function (endIndex) {
	        var now = new Date().getTime();
	        var self = this;
	
	        if (now - this.startTime < 3000) {
	            setTimeout(function () {
	                self.endIndex = endIndex - (self.maxInterval - self.currentInterval) / self.stepInterval + 1;
	                if (self.endIndex < 0) {
	                    self.endIndex += self.list.length;
	                }
	            }, 3000 - now + this.startTime);
	        } else {
	            self.endIndex = endIndex - (self.maxInterval - self.currentInterval) / self.stepInterval + 1;
	            if (self.endIndex < 0) {
	                self.endIndex += self.list.length;
	            }
	        }
	    },
	    step: function () {
	        var self = this;
	
	        if (this.immediateStop) {
	            this.onEnd();
	            this.status = 'stop';
	            this.immediateStop = false;
	            return;
	        }
	
	        var timer = setTimeout(function () {
	            self.onStep(self.index);
	            self.index++;
	            self.index >= self.list.length && (self.index = 0);
	
	            if (self.index === self.endIndex) {
	                self.status = 'end';
	            }
	
	            self.step(self.index);
	        }, self.currentInterval);
	
	        if (self.status === 'start') {
	            self.currentInterval -= self.stepInterval;
	        } else if (self.status === 'end') {
	            self.currentInterval += self.stepInterval;
	        }
	
	        if (self.currentInterval < self.minInterval) {
	            self.currentInterval = self.minInterval;
	            self.status = 'process';
	        } else if (self.currentInterval > self.maxInterval) {
	            self.currentInterval = self.maxInterval;
	            this.onEnd();
	            this.status = 'stop';
	            this.endIndex = void 0;
	            clearTimeout(timer);
	        }
	    }
	}
	
	module.exports = Draw;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js